module.exports = __webpack_public_path__ + "img/PMS_Moore.f8b62960.gif";